import { useMemo } from 'react';
import { useCurrentUser } from '../api/endpoints/useCurrentUser';
import { useClientId } from './useClientId';

export function useEntityFormAdditionalContext() {
  const clientId = useClientId();
  const { data: currentUserResponse, isLoading } = useCurrentUser(clientId);

  const additionalContext = useMemo(() => {
    const userData = currentUserResponse?.data?.entityData;

    if (!userData) {
      return {};
    }

    return {
      _currentUser: {
        ...userData,
        localeSettings: userData.localeSettings || {},
      },
    };
  }, [currentUserResponse]);

  return { additionalContext, isLoading };
}
